<!-- Header da Página -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-shopping-bag"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'criar_pedido.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'criar_pedido.subtitulo' | translate }}</p>
  </div>
</div>

<div class="container">
  <div class="tabPanel-container">
    <!-- COLUNA ESQUERDA (lista de produtos) -->
    <div class="item item1">

      <!-- Chips de Categoria -->
      <div class="categorias-chips-container">
        <div class="chips-scroll">
          <!-- Setas: aparecem só no lado que tem categoria escondida -->
          <button
            type="button"
            class="chips-scroll-nav chips-scroll-nav-esquerda"
            [disabled]="!dsCategorias.podeRolarEsquerda"
            [attr.aria-label]="'common.chips_scroll.anterior' | translate"
            (click)="dsCategorias.rolar(-1)">
            <i class="pi pi-chevron-left" aria-hidden="true"></i>
          </button>

          <div
            class="categorias-chips chips-scroll-viewport"
            appDragScroll
            #dsCategorias="appDragScroll"
            [class.tem-esquerda]="dsCategorias.podeRolarEsquerda"
            [class.tem-direita]="dsCategorias.podeRolarDireita">
            <button
              *ngFor="let grupo of grupos"
              class="chip-categoria"
              [class.chip-ativo]="categoriaSelecionada?.id === grupo.id"
              (click)="selecionarCategoria(grupo)">
              <img
                *ngIf="grupo.imagem"
                class="chip-categoria-img"
                [src]="env.imgHost + '/' + idEmpresa + '/grupo/' + grupo.imagem"
                [alt]="grupo.nome"
                (error)="onImageError($event)" />
              <i *ngIf="!grupo.imagem && grupo.id !== null" class="pi pi-th-large chip-categoria-icon"></i>
              <i *ngIf="grupo.id === null" class="pi pi-list chip-categoria-icon"></i>
              <span *ngIf="grupo.id !== null">{{ grupo.nome }}</span>
              <span *ngIf="grupo.id === null">{{ 'criar_pedido.todas_categorias' | translate }}</span>
            </button>
          </div>

          <button
            type="button"
            class="chips-scroll-nav chips-scroll-nav-direita"
            [disabled]="!dsCategorias.podeRolarDireita"
            [attr.aria-label]="'common.chips_scroll.proximo' | translate"
            (click)="dsCategorias.rolar(1)">
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <!-- Busca + Checkbox na mesma linha -->
      <div class="search-bar">
        <div class="search-bar-row">
          <div class="search-field-wrapper search-field">
            <p-iconField iconPosition="right">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput type="text" (input)="onInputChange($event)" (keydown.enter)="onSearchEnter($event)" pInputText
                [placeholder]="'criar_pedido.buscar_ph' | translate" class="w-full" />
            </p-iconField>
          </div>
          <div class="checkbox-sem-saldo">
            <p-checkbox
              inputId="ck-sem-saldo"
              [(ngModel)]="mostrarSemSaldo"
              binary="true"
              (onChange)="onToggleSemSaldo()">
            </p-checkbox>
            <label for="ck-sem-saldo">{{ 'criar_pedido.mostrar_sem_saldo' | translate }}</label>
          </div>

          <!-- Qual codigo aparece no card do produto (nenhum por padrao) -->
          <div class="seletor-codigo">
            <label for="dd-codigo-card">{{ 'criar_pedido.codigo_exibir' | translate }}</label>
            <p-dropdown
              inputId="dd-codigo-card"
              [options]="codigoOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="exibicaoCodigo"
              (ngModelChange)="onExibicaoCodigoChange()"
              appendTo="body"
              styleClass="dd-codigo">
            </p-dropdown>
          </div>
        </div>
      </div>

      <!-- Grid de produtos -->
      <div class="produtos-grid" *ngIf="!loading && !produtoNaoEncontrado; else skeleton">
        <div
          class="produto-item"
          *ngFor="let produto of produtos"
          tabindex="0"
          [pTooltip]="'criar_pedido.adicionar_produto' | translate"
          tooltipPosition="top"
          [class.disabled-card]="!podeClicar(produto)"
          (click)="podeClicar(produto) && adicionarProduto(produto)"
          (keydown.enter)="podeClicar(produto) && adicionarProduto(produto)">

          <!-- Container de imagem com aspect-ratio fixo -->
          <div class="produto-img-container">
            <img
              [src]="env.imgHost + '/' + idEmpresa + '/item/' + produto.imagem"
              [alt]="produto.nome"
              [attr.data-product-id]="produto.id"
              (error)="onImageError($event)"
              [class.img-hidden]="temErroImagem(produto)" />
            <svg *ngIf="temErroImagem(produto)"
                 class="placeholder-svg" viewBox="0 0 160 90" fill="none"
                 xmlns="http://www.w3.org/2000/svg"
                 aria-hidden="true">
              <rect width="160" height="90" rx="8" class="placeholder-bg"/>
              <rect x="55" y="25" width="50" height="40" rx="4" class="placeholder-border"
                    stroke-width="2" fill="none"/>
              <path d="M65 55l8-10 6 6 14-16v20H65z" class="placeholder-icon"/>
              <circle cx="72" cy="35" r="4" class="placeholder-icon"/>
            </svg>
          </div>

          <!-- Informações do produto -->
          <h3 class="produto-nome">{{ produto.nome }}</h3>
          <p class="produto-cod" *ngIf="textoDoCodigo(produto, exibicaoCodigo) as cod">{{ cod }}</p>

          <!-- Preço em destaque -->
          <p class="produto-preco" *ngIf="moedaPadrao === 'PYG'">{{ produto.precoDeVenda | guaraniFormat }}</p>
          <p class="produto-preco" *ngIf="moedaPadrao !== 'PYG'">
            {{ produto.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
          </p>

          <!-- Badge de estoque (serviço não controla estoque, igual à venda) -->
          <span *ngIf="ehServico(produto); else badgeMercadoria" class="badge-estoque badge-servico">
            {{ 'criar_pedido.servico' | translate }}
          </span>
          <ng-template #badgeMercadoria>
            <span *ngIf="!indisponivel(produto)" class="badge-estoque badge-disponivel">
              {{ 'criar_pedido.em_estoque' | translate }} {{ produto.saldo | number:'1.0-0' }}
            </span>
            <span *ngIf="indisponivel(produto)" class="badge-estoque badge-indisponivel">
              {{ 'criar_pedido.indisponivel' | translate }}
            </span>
          </ng-template>
        </div>
      </div>

      <div *ngIf="!loading && produtoNaoEncontrado" class="vm-empty-state" style="padding: 48px 16px;">
        <i class="pi pi-box" style="font-size: 2rem;"></i>
        <span>{{ 'criar_pedido.produto_nao_encontrado' | translate }}</span>
      </div>

      <!-- Skeleton Loader -->
      <ng-template #skeleton>
        <div class="produtos-grid" *ngIf="!produtoNaoEncontrado">
          <div class="skeleton-card" *ngFor="let i of [1,2,3,4,5,6,7,8]">
            <div class="skeleton-img-container">
              <p-skeleton width="100%" height="100%" borderRadius="0"></p-skeleton>
            </div>
            <p-skeleton width="90%" height="14px" styleClass="skeleton-nome-linha1"></p-skeleton>
            <p-skeleton width="60%" height="14px"></p-skeleton>
            <p-skeleton width="40%" height="10px" styleClass="skeleton-cod"></p-skeleton>
            <p-skeleton width="50%" height="20px" styleClass="skeleton-preco"></p-skeleton>
            <p-skeleton width="55%" height="22px" borderRadius="12px" styleClass="skeleton-badge"></p-skeleton>
          </div>
        </div>
      </ng-template>

      <!-- Paginação — mesmo padrão da tela de vendas (Variante A): contagem +
           navegação à esquerda, "Itens por página" à direita. O seletor de
           tamanho sai de dentro do p-paginator e vira dropdown rotulado, senão
           fica um "10" solto sem dizer do que se trata. -->
      <div class="pagination-container" *ngIf="!produtoNaoEncontrado">
        <div>
          <p-paginator
            [rows]="tamanhoPagina"
            [totalRecords]="totalElements"
            [first]="paginaAtual * tamanhoPagina"
            (onPageChange)="onPaginatorChange($event)"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="'criar_pedido.contagem' | translate"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ 'criar_pedido.itens_por_pagina' | translate }}</span>
          <p-dropdown
            [options]="pageSizeOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="tamanhoPagina"
            (ngModelChange)="onRowsPerPageChange()"
            styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>

    <!-- COLUNA DIREITA (carrinho) -->
    <div class="item item2">
      <p-card id="pagamentoVendas">
        <!-- Bloco seleção/ações (apenas Cliente — sem timbrado) -->
        <div class="customer-card">
          <div class="campo-vendas">
            <label>{{ 'criar_pedido.cliente' | translate }} <span class="obrigatorio">*</span></label>
            <div class="cliente-input-row">
              <app-entity-selector
                [config]="clienteSelectorConfig"
                [(value)]="clienteSelecionado"
                (entitySelected)="onClienteSelecionado()"
                (addNew)="abrirDialogNovoCliente()">
              </app-entity-selector>
            </div>
          </div>

          <button
            pButton
            class="btn-limpar-carrinho"
            (click)="limparCarrinho()">
            {{ 'criar_pedido.limpar_carrinho' | translate }}
          </button>
        </div>

        <!-- Tabela do Carrinho -->
        <span *ngIf="carrinho.length == 0">{{ 'criar_pedido.nenhum_item_selecionado' | translate }}</span>

        <div class="tabela-itens cart-table" *ngIf="carrinho.length > 0">
          <table>
            <thead>
              <tr>
                <th>{{ 'criar_pedido.col_item' | translate }}</th>
                <th class="text-center">{{ 'criar_pedido.col_qtd' | translate }}</th>
                <th class="text-right">{{ 'criar_pedido.col_valor' | translate }}</th>
                <th class="text-right">{{ 'criar_pedido.col_subtotal' | translate }}</th>
                <th class="text-center">{{ 'criar_pedido.col_acao' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of carrinho">
                <td>
                  <div class="cart-item-cell" [pTooltip]="item.nome" tooltipPosition="left">
                    <span class="cart-item-name">{{ item.nome }}</span>
                    <small class="cart-item-cod" *ngIf="textoDoCodigo(item, exibicaoCodigo) as cod">
                      {{ cod }}
                    </small>
                    <!-- Personalização (variante / adicionais / observação) -->
                    <small
                      *ngIf="item.varianteDescricao || item.modificadoresDescricao || item.observacaoItem"
                      class="cart-item-detalhes">
                      <span *ngIf="item.varianteDescricao">
                        {{ 'vendas.variantes.variante' | translate }}: {{ item.varianteDescricao }}
                      </span>
                      <span *ngIf="item.varianteDescricao && item.modificadoresDescricao"> | </span>
                      <span *ngIf="item.modificadoresDescricao">
                        {{ 'vendas.variantes.adicionais' | translate }}: {{ item.modificadoresDescricao }}
                      </span>
                      <span *ngIf="item.observacaoItem" class="cart-item-obs">
                        <i class="pi pi-comment"></i> {{ item.observacaoItem }}
                      </span>
                    </small>

                    <!-- Observação manual do item (paridade com o mobile) -->
                    <div class="cart-item-obs-manual">
                      <!-- Preenchida: texto fixo + ícone de edição -->
                      <button
                        *ngIf="temObservacaoManual(item); else chipAddObs"
                        type="button"
                        class="obs-manual-preenchida"
                        [pTooltip]="'criar_pedido.observacao_item_editar' | translate"
                        tooltipPosition="top"
                        (click)="abrirObservacaoItem(item)">
                        <i class="pi pi-pencil"></i>
                        <span class="obs-manual-texto">{{ item.observacaoManual }}</span>
                      </button>
                      <!-- Vazia: chip evidente "Adicionar observação" -->
                      <ng-template #chipAddObs>
                        <button
                          type="button"
                          class="obs-manual-chip"
                          (click)="abrirObservacaoItem(item)">
                          <i class="pi pi-comment"></i>
                          <span>{{ 'criar_pedido.observacao_item_adicionar' | translate }}</span>
                        </button>
                      </ng-template>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="quantidade-controles">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-minus"
                      class="btn-decrementar"
                      (click)="decrementarQuantidade(item)">
                    </button>
                    <input
                      type="number"
                      [(ngModel)]="item.quantidade"
                      (change)="ajustarQuantidade(item)"
                      [attr.max]="item.controlaSaldo ? item.saldo : null"
                      min="1"
                      class="input-quantidade-carrinho" />
                    <button
                      pButton
                      type="button"
                      icon="pi pi-plus"
                      class="btn-incrementar"
                      (click)="incrementarQuantidade(item)">
                    </button>
                  </div>
                </td>

                <td class="text-right" *ngIf="moedaPadrao === 'PYG'">{{ item.valorUnitario | guaraniFormat }}</td>
                <td class="text-right" *ngIf="moedaPadrao !== 'PYG'">
                  {{ item.valorUnitario | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
                </td>

                <td class="text-right" *ngIf="moedaPadrao === 'PYG'">{{ subtotalLinha(item) | guaraniFormat }}</td>
                <td class="text-right" *ngIf="moedaPadrao !== 'PYG'">
                  {{ subtotalLinha(item) | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
                </td>

                <td>
                  <button
                    pButton
                    icon="pi pi-trash"
                    class="btn-remover-item"
                    (click)="removerLinha(item)">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Resumo financeiro (sem desconto) -->
        <div class="payment-summary">
          <div class="summary-line">
            <span>{{ 'criar_pedido.quantidade_total_itens' | translate }}</span>
            <span>{{ quantidadeTotalItens }}</span>
          </div>

          <div class="summary-line">
            <span>{{ 'criar_pedido.subtotal' | translate }}</span>
            <span *ngIf="moedaPadrao === 'PYG'">{{ calcularSubtotal() | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">
              {{ calcularSubtotal() | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
            </span>
          </div>

          <div class="summary-total">
            <span class="total-label">{{ 'criar_pedido.total' | translate }}</span>
            <span class="total-valor" *ngIf="moedaPadrao === 'PYG'">{{ total | guaraniFormat }}</span>
            <span class="total-valor" *ngIf="moedaPadrao !== 'PYG'">
              {{ total | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
            </span>
          </div>
        </div>

        <!-- Observação -->
        <div class="observacao-container">
          <label for="observacao">{{ 'criar_pedido.observacao' | translate }}</label>
          <textarea
            id="observacao"
            [(ngModel)]="observacao"
            [placeholder]="'criar_pedido.observacao_ph' | translate">
          </textarea>
        </div>

        <!-- Ações -->
        <div class="payment-actions">
          <button
            pButton
            class="p-button btn-finalizar"
            [disabled]="!podeCriar"
            (click)="abrirConfirmacao()">
            {{ 'criar_pedido.criar' | translate }}
          </button>
        </div>
      </p-card>
    </div>
  </div>
</div>

<!-- Popup de confirmação: modalidade + mesa/comanda + delivery + total (wave) -->
<p-dialog
  [(visible)]="mostrarConfirmacao"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ maxWidth: '96vw' }"
  [styleClass]="'dialog-wave-redesign criar-pedido-confirmar' + (ehDelivery ? ' cp-confirmar-wide' : '')"
  (onHide)="onFecharConfirmacao()">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-shopping-bag" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'criar_pedido.confirmar_titulo' | translate }}</h2>
        <p>{{ 'criar_pedido.confirmar_subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <!-- Modalidade -->
    <div class="field">
      <label>{{ 'criar_pedido.modalidade' | translate }}</label>
      <p-selectButton
        [options]="modalidadeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="modalidade"
        [allowEmpty]="false"
        (onChange)="onModalidadeChange()"
        styleClass="w-full">
      </p-selectButton>
    </div>

    <!-- Mesa / comanda: so no consumo local, e so o que a loja configurou como exigido.
         O interruptor decide as duas coisas de uma vez — o campo aparece porque e exigido. -->
    <div class="dados-linha" *ngIf="modalidade === 'LOCAL' && (exigenciasDoPedido.numeroDaMesa || exigenciasDoPedido.numeroDaComanda)">
      <div class="field" *ngIf="exigenciasDoPedido.numeroDaMesa">
        <label>
          {{ 'criar_pedido.numero_mesa' | translate }}
          <span class="required">*</span>
        </label>
        <input pInputText type="number" min="1" class="w-full"
          [(ngModel)]="mesa"
          [placeholder]="'criar_pedido.obrigatorio' | translate" />
      </div>
      <div class="field" *ngIf="exigenciasDoPedido.numeroDaComanda">
        <label>
          {{ 'criar_pedido.numero_comanda' | translate }}
          <span class="required">*</span>
        </label>
        <input pInputText type="number" min="1" class="w-full"
          [(ngModel)]="comanda"
          [placeholder]="'criar_pedido.obrigatorio' | translate" />
      </div>
    </div>

    <!-- Dados de entrega (só delivery) -->
    <ng-container *ngIf="ehDelivery">
      <div class="secao-delivery-titulo">{{ 'criar_pedido.dados_entrega' | translate }}</div>

      <!-- Duas colunas: campos à esquerda, mapa fixo (sticky) à direita. -->
      <div class="delivery-grid">
        <div class="delivery-col-form">
          <div class="field">
            <label>{{ 'criar_pedido.endereco_entrega' | translate }} <span class="obrigatorio">*</span></label>
            <div class="endereco-busca-row">
              <input pInputText type="text" class="w-full"
                [(ngModel)]="enderecoEntregaRua"
                (keydown.enter)="$event.preventDefault(); buscarEnderecoNoMapa()"
                [placeholder]="'criar_pedido.endereco_entrega_ph' | translate" />
              <button pButton type="button"
                icon="pi pi-search"
                class="btn-buscar-endereco"
                [pTooltip]="'criar_pedido.buscar_no_mapa' | translate"
                tooltipPosition="top"
                [disabled]="geocodificando"
                (click)="buscarEnderecoNoMapa()">
              </button>
            </div>
            <div *ngIf="geocodificando" class="delivery-geocod">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ 'criar_pedido.buscando_endereco' | translate }}</span>
            </div>
          </div>

          <div class="dados-linha">
            <div class="field">
              <label>{{ 'criar_pedido.numero_entrega' | translate }}</label>
              <input pInputText type="text" class="w-full"
                [(ngModel)]="numeroEntrega"
                [placeholder]="'criar_pedido.numero_entrega_ph' | translate" />
            </div>
            <div class="field">
              <label>{{ 'criar_pedido.complemento_entrega' | translate }}</label>
              <input pInputText type="text" class="w-full"
                [(ngModel)]="complementoEntrega"
                [placeholder]="'criar_pedido.complemento_entrega_ph' | translate" />
            </div>
          </div>

          <div class="field">
            <label>{{ 'criar_pedido.referencia_entrega' | translate }}</label>
            <input pInputText type="text" class="w-full"
              [(ngModel)]="referenciaEntrega"
              [placeholder]="'criar_pedido.referencia_entrega_ph' | translate" />
          </div>

          <!-- Cidade: refina a busca do endereço (a mesma rua existe em várias cidades) -->
          <div class="field">
            <label>{{ 'criar_pedido.cidade_entrega' | translate }}</label>
            <p-dropdown
              [options]="cidadesEntrega"
              [(ngModel)]="cidadeEntregaSelecionada"
              optionLabel="label"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              [placeholder]="'criar_pedido.cidade_entrega_ph' | translate"
              (onChange)="onCidadeEntregaChange()"
              styleClass="w-full"
              appendTo="body">
            </p-dropdown>
          </div>

          <div class="field">
            <label>{{ 'criar_pedido.valor_frete' | translate }}</label>
            <p-inputNumber
              [(ngModel)]="valorFrete"
              [min]="0"
              mode="decimal"
              [locale]="localeMoeda"
              [minFractionDigits]="decimaisMoeda"
              [maxFractionDigits]="decimaisMoeda"
              [useGrouping]="true"
              styleClass="w-full">
            </p-inputNumber>
          </div>

          <!-- Forma de pagamento: as opções e a própria exibição seguem a
               configuração do minishop. Sem "perguntar a forma de pagamento",
               a seção não aparece. -->
          <div class="field" *ngIf="exibirFormasPagamento">
            <div class="secao-delivery-titulo secao-delivery-titulo--forma-pagamento">
              {{ 'criar_pedido.forma_pagamento' | translate }}
            </div>
            <p class="forma-pagamento-ajuda">{{ 'criar_pedido.forma_pagamento_ajuda' | translate }}</p>
            <p-selectButton
              [options]="formaPagamentoOptions"
              optionValue="value"
              [ngModel]="formaPagamento"
              (ngModelChange)="selecionarFormaPagamento($event)"
              [allowEmpty]="false"
              styleClass="w-full selectbutton-forma-pagamento">
              <ng-template let-item pTemplate="item">
                <i [class]="item.icon" aria-hidden="true"></i>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-selectButton>

            <!--
              QR Code: a cobrança nasce AQUI, antes de confirmar o pedido — igual à venda.
              O cliente paga primeiro; só então o pedido é criado, já pago e faturado. Assim não
              sobra pedido órfão de quem desistiu no meio.
            -->
            <div class="pagamento-detalhe" *ngIf="formaPagamento === 'QR_CODE' && exibirFormasPagamento">
              <!-- A conta do QR vem de Dados de recebimento, nao da tela. Sem ela nao ha cobranca:
                   o pedido e criado com a forma registrada e o pagamento combinado depois, como
                   nas demais formas. -->
              <small class="pagamento-aviso" *ngIf="!contaQrCode">
                {{ 'criar_pedido.qrcode_sem_conta_configurada' | translate }}
              </small>

              <div class="pagamento-conta-fixa" *ngIf="contaQrCode">
                <label class="pagamento-label">{{ 'criar_pedido.conta_destino' | translate }}</label>
                <span>{{ contaQrCode.label }}</span>
              </div>

              <button *ngIf="!cobrancaQrCode && contaQrCode"
                pButton type="button"
                class="w-full"
                [icon]="gerandoQrCode ? 'pi pi-spin pi-spinner' : 'pi pi-qrcode'"
                [label]="'criar_pedido.gerar_qrcode' | translate"
                [disabled]="gerandoQrCode"
                (click)="gerarQrCode()">
              </button>

              <!-- #blocoQrCodePedido: alvo do scroll automatico — o dialogo rola sozinho ate o
                   codigo assim que ele e gerado, e de novo quando o pagamento e confirmado. -->
              <div class="qrcode-pedido" *ngIf="cobrancaQrCode" #blocoQrCodePedido>
                <img *ngIf="cobrancaQrCode.urlQr"
                     class="qrcode-imagem"
                     [src]="cobrancaQrCode.urlQr"
                     [alt]="'criar_pedido.qrcode_titulo' | translate" />

                <div class="qrcode-aguardando" *ngIf="!qrCodeConfirmado">
                  <span class="qrcode-aguardando-titulo">
                    <i class="pi pi-spin pi-spinner"></i>
                    {{ 'criar_pedido.qrcode_aguardando' | translate }}
                  </span>
                  <span class="qrcode-ajuda">{{ 'criar_pedido.qrcode_ajuda' | translate }}</span>
                </div>

                <div class="qrcode-confirmado" *ngIf="qrCodeConfirmado">
                  <i class="pi pi-check-circle"></i>
                  <span>{{ 'criar_pedido.qrcode_confirmado' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna direita: mapa fixo (clique/arraste para marcar o ponto) -->
        <div class="delivery-col-mapa">
          <div class="mapa-entrega" id="map-entrega-pedido"></div>
          <div class="mapa-acoes">
            <span class="mapa-dica">{{ 'criar_pedido.toque_no_mapa' | translate }}</span>
            <button pButton type="button"
              class="p-button-text p-button-sm btn-localizacao"
              [icon]="obtendoLocalizacao ? 'pi pi-spin pi-spinner' : 'pi pi-map-marker'"
              [label]="'criar_pedido.usar_minha_localizacao' | translate"
              [disabled]="obtendoLocalizacao"
              (click)="usarMinhaLocalizacao()">
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Totais -->
    <div class="confirmar-totais">
      <ng-container *ngIf="ehDelivery">
        <div class="confirmar-linha">
          <span>{{ 'criar_pedido.subtotal' | translate }}</span>
          <span *ngIf="moedaPadrao === 'PYG'">{{ total | guaraniFormat }}</span>
          <span *ngIf="moedaPadrao !== 'PYG'">{{ total | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
        </div>
        <div class="confirmar-linha">
          <span>{{ 'criar_pedido.valor_frete' | translate }}</span>
          <span *ngIf="moedaPadrao === 'PYG'">{{ valorFrete | guaraniFormat }}</span>
          <span *ngIf="moedaPadrao !== 'PYG'">{{ valorFrete | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
        </div>
      </ng-container>
      <div class="confirmar-total">
        <span class="total-label">{{ 'criar_pedido.total' | translate }}</span>
        <span class="total-valor" *ngIf="moedaPadrao === 'PYG'">{{ totalComFrete | guaraniFormat }}</span>
        <span class="total-valor" *ngIf="moedaPadrao !== 'PYG'">
          {{ totalComFrete | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
        </span>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [label]="'criar_pedido.cancelar' | translate"
      (click)="mostrarConfirmacao = false">
    </button>
    <button pButton icon="pi pi-check"
      [label]="'criar_pedido.confirmar' | translate"
      [loading]="salvando"
      [disabled]="salvando || !pagamentoQrCodePronto"
      (click)="criarPedido()">
    </button>
  </ng-template>
</p-dialog>

<!-- Diálogo de cadastro de pessoa (mesma "Agregar Persona" da tela de Vendas) -->
<app-pessoa-adicionar-dialog
  [(visible)]="mostrarDialogNovoCliente"
  tipo="cliente"
  (pessoaCriada)="onClienteCriado($event)"
  (pessoaVinculada)="onClienteVinculado($event)">
</app-pessoa-adicionar-dialog>

<!-- Diálogo: observação por item do carrinho (paridade com o bottom sheet do mobile) -->
<p-dialog
  [(visible)]="mostrarDialogObservacao"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [header]="'criar_pedido.observacao_item_titulo' | translate"
  [style]="{ width: '30rem', maxWidth: '94vw' }"
  styleClass="dialog-observacao-item"
  (onHide)="fecharObservacaoItem()">
  <div class="obs-item-body">
    <label for="obs-item-textarea">{{ 'criar_pedido.observacao_item_label' | translate }}</label>
    <textarea
      id="obs-item-textarea"
      pInputTextarea
      rows="4"
      class="w-full"
      [(ngModel)]="observacaoEmEdicao"
      [placeholder]="'criar_pedido.observacao_item_ph' | translate"></textarea>
  </div>
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [label]="'criar_pedido.cancelar' | translate"
      (click)="mostrarDialogObservacao = false">
    </button>
    <button pButton icon="pi pi-check"
      [label]="'criar_pedido.observacao_item_salvar' | translate"
      (click)="salvarObservacaoItem()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de valor de venda para item com preço 0 (paridade com a venda) -->
<p-dialog
  [(visible)]="mostrarDialogPreco"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="'criar_pedido.definir_preco_titulo' | translate"
  [style]="{ width: '26rem', maxWidth: '94vw' }"
  (onShow)="focarInputPreco()"
  (onHide)="cancelarNovoPreco()">
  <div class="obs-item-body">
    <p class="texto-definir-preco">
      {{ 'criar_pedido.definir_preco_desc' | translate: { produto: produtoParaDefinirPreco?.nome, producto: produtoParaDefinirPreco?.nome } }}
    </p>
    <label for="novo-preco-venda">{{ 'criar_pedido.definir_preco_label' | translate }}</label>
    <p-inputNumber
      #inputNovoPreco
      inputId="novo-preco-venda"
      [(ngModel)]="novoPrecoDeVenda"
      [min]="0"
      mode="decimal"
      [locale]="localeMoeda"
      [minFractionDigits]="decimaisMoeda"
      [maxFractionDigits]="decimaisMoeda"
      [useGrouping]="true"
      (keydown.enter)="confirmarNovoPreco()"
      styleClass="w-full">
    </p-inputNumber>
  </div>
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [label]="'criar_pedido.cancelar' | translate"
      (click)="cancelarNovoPreco()">
    </button>
    <button pButton icon="pi pi-check"
      [label]="'criar_pedido.definir_preco_confirmar' | translate"
      [disabled]="!novoPrecoDeVenda || novoPrecoDeVenda <= 0"
      (click)="confirmarNovoPreco()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de seleção de variante/modificadores (reaproveitado do PDV) -->
<app-variante-modificador-dialog
  [produto]="produtoParaPersonalizar"
  [idEmpresa]="idEmpresa"
  [moedaPadrao]="moedaPadrao"
  [digitsMoeda]="digitsMoeda"
  [localeMoeda]="localeMoeda"
  (semOpcoes)="onProdutoSemOpcoes($event)"
  (confirmar)="onPersonalizacaoConfirmada($event)"
  (cancelar)="onPersonalizacaoCancelada()">
</app-variante-modificador-dialog>
